import { render, staticRenderFns } from "./StarAuthorPanel.vue?vue&type=template&id=6b377d8a&scoped=true&"
import script from "./StarAuthorPanel.vue?vue&type=script&lang=js&"
export * from "./StarAuthorPanel.vue?vue&type=script&lang=js&"
import style0 from "./StarAuthorPanel.vue?vue&type=style&index=0&id=6b377d8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b377d8a",
  null
  
)

export default component.exports